import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './gerunds-explanation';

const mainimage = '/Images/gerunds1.webp';


const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "gerunds" },
];

const Gerunds = () => (
  <GrammarPageLayout
    level="B1"
    title="Gerunds"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Gerunds and Verb Form Exercises"
    seoDescription="Practice verbs followed by -ing forms: enjoy, avoid, suggest, and more. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);



export default Gerunds;

